// Generated by ReScript, PLEASE EDIT WITH CARE


function formStatusValueToString(status) {
  switch (status) {
    case "Empty" :
      return "EMPTY";
    case "Filling" :
      return "FILLING";
    case "Complete" :
      return "COMPLETE";
  }
}

function formStatusValueFromString(str) {
  switch (str) {
    case "COMPLETE" :
      return "Complete";
    case "FILLING" :
      return "Filling";
    default:
      return "Empty";
  }
}

function eventToString(eventType) {
  switch (eventType) {
    case "CardDetailsChange" :
      return "cardDetailsChange";
    case "PaymentMethodChange" :
      return "paymentMethodChange";
    case "FormStatusChange" :
      return "formStatusChange";
    case "BillingDetailsChange" :
      return "billingDetailsChange";
    case "CvcStatusChange" :
      return "cvcStatusChange";
    case "SurchargeInfo" :
      return "surchargeInfo";
    case "AppliedOffersInfo" :
      return "appliedOffersInfo";
    case "UnknownEvent" :
      return "unknownEvent";
  }
}

function eventFromString(str) {
  switch (str) {
    case "appliedOffersInfo" :
      return "AppliedOffersInfo";
    case "billingDetailsChange" :
      return "BillingDetailsChange";
    case "cardDetailsChange" :
      return "CardDetailsChange";
    case "cvcStatusChange" :
      return "CvcStatusChange";
    case "formStatusChange" :
      return "FormStatusChange";
    case "paymentMethodChange" :
      return "PaymentMethodChange";
    case "surchargeInfo" :
      return "SurchargeInfo";
    default:
      return "UnknownEvent";
  }
}

export {
  formStatusValueToString,
  formStatusValueFromString,
  eventToString,
  eventFromString,
}
/* No side effect */
